import type { ReactNode } from 'react';
import SvgAsset from '../SvgAsset';
import type { FieldValidationState } from './fieldValidation';

const checkThickSolidSrc = '/auth/assets/svgs/icons/check-thick-solid.svg';
const delete2SolidSrc = '/auth/assets/svgs/icons/delete-2-solid.svg';

type LabelWithTooltipProps = {
    label: ReactNode;
    htmlFor?: string;
    validationState?: FieldValidationState;
};

function joinClasses(...classes: Array<string | false | null | undefined>) {
    return classes.filter(Boolean).join(' ');
}

function isValidationStateVisible(validationState?: FieldValidationState) {
    return validationState === 'valid' || validationState === 'invalid';
}

export default function LabelWithTooltip({
    label,
    htmlFor,
    validationState,
}: LabelWithTooltipProps) {
    const showValidationState = isValidationStateVisible(validationState);
    const labelClasses = joinClasses(
        'block',
        'transform',
        showValidationState ? 'translate-x-2' : '-translate-x-3.5',
        'transition-transform',
    );
    const validationText = validationState === 'valid' ? 'Valid' : 'Invalid';

    return (
        <div className="flex items-center justify-between">
            <div className="flex items-center justify-start">
                <span
                    className={joinClasses(
                        'flex-none',
                        validationState === 'valid' && 'text-avocado',
                        validationState === 'invalid' && 'text-paprika',
                        'w-4 h-4',
                        showValidationState ? 'opacity-100' : 'opacity-0',
                        'transform -translate-y-px',
                    )}
                    aria-hidden="true"
                >
                    {validationState ? (
                        <SvgAsset
                            src={validationState === 'valid' ? checkThickSolidSrc : delete2SolidSrc}
                            className="h-4 w-4 transform -translate-y-px"
                        />
                    ) : null}
                </span>

                <span className="label">
                    {htmlFor ? (
                        <label htmlFor={htmlFor} className={labelClasses}>
                            {label}
                            {validationState ? (
                                <span className="sr-only">{validationText}</span>
                            ) : null}
                        </label>
                    ) : (
                        <span className={labelClasses}>
                            {label}
                            {validationState ? (
                                <span className="sr-only">{validationText}</span>
                            ) : null}
                        </span>
                    )}
                </span>
            </div>
        </div>
    );
}
